import React from 'react';
import styled from 'styled-components';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';

import Carousel from '../heroBlock/Carousel';

const messages = defineMessages({
  gramophone: {
    id: 'reviews.press.gramophone',
    defaultMessage: '“A rarity in the streaming world.”',
  },
  vogue: {
    id: 'reviews.press.vogue',
    defaultMessage: '“IDAGIO has changed my life.”',
  },
  bloomberg: {
    id: 'reviews.press.bloomberg',
    defaultMessage: '“Spotify for classical music buffs.”',
  },
  losAngelesTimes: {
    id: 'reviews.press.los-angeles-times',
    defaultMessage: '“The most capable search… The curation is lovingly personal.”',
  },
  goToQuote: {
    id: 'reviews.go-to-quote',
    defaultMessage: 'Go to quote {number}',
  },
});

export const PRESS_QUOTES = [
  { source: 'Gramophone', quote: messages.gramophone },
  { source: 'Vogue', quote: messages.vogue },
  { source: 'Bloomberg Businessweek', quote: messages.bloomberg },
  { source: 'Los Angeles Times', quote: messages.losAngelesTimes },
];

const DOT_SIZE = '0.625rem';

const Wrapper = styled.div`
  background-color: var(--c-black);
  border-radius: var(--fr);
  overflow: hidden;
  padding: calc(var(--fr) * 2) calc(var(--fr) * 1.5);
  position: relative;
  min-height: 20rem;

  ${media.large`
    padding: calc(var(--fr) * 3);
    min-height: unset;
    border-radius: 0 var(--fr) var(--fr) 0;
  `}
`;

const Quotes = styled(Carousel)`
  height: 100%;

  .slick-slider {
    position: static;
  }

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-initialized .slick-slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  ${media.large`
    height: auto;

    .slick-slider,
    .slick-list,
    .slick-track {
      height: auto;
    }
  `}

  .slick-dots {
    bottom: calc(var(--fr) * 1.5);
    left: auto;
    right: calc(var(--fr) * 1.5);
    text-align: right;
    width: auto;

    ${media.large`
      bottom: calc(var(--fr) * 2);
      right: calc(var(--fr) * 3);
    `}
  }

  .slick-dots li {
    height: ${DOT_SIZE};
    margin: 0 0 0 0.5rem;
    width: ${DOT_SIZE};
  }

  .slick-dots li button {
    height: ${DOT_SIZE};
    padding: 0;
    width: ${DOT_SIZE};
  }

  .slick-dots li button:before {
    background-color: var(--c-slate);
    border-radius: 50%;
    content: '';
    height: ${DOT_SIZE};
    opacity: 1;
    width: ${DOT_SIZE};
  }

  .slick-dots li.slick-active button:before {
    background-color: var(--c-white);
  }
`;

const Quote = styled.blockquote`
  font-size: var(--fs-ml);
  ${legacyType('ml', 'title')};
  margin: 0;
`;

const Source = styled.figcaption`
  color: var(--c-manatee);
  font-size: var(--fs-sm);
  font-weight: 600;
  ${legacyType('sm', 'label', { emphasis: true, uppercase: true })};
  margin-top: calc(var(--fr) * 1.5);
  text-transform: uppercase;
`;

const PressQuotes = ({ intl }) => {
  const settings = {
    arrows: false,
    autoplay: false,
    customPaging: index => (
      <button
        type="button"
        aria-label={intl.formatMessage(messages.goToQuote, { number: index + 1 })}
      />
    ),
  };

  return (
    <Wrapper>
      <Quotes settings={settings}>
        {PRESS_QUOTES.map(({ source, quote }) => (
          <figure key={source}>
            <Quote>{intl.formatMessage(quote)}</Quote>
            <Source>{source}</Source>
          </figure>
        ))}
      </Quotes>
    </Wrapper>
  );
};

PressQuotes.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(PressQuotes);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/reviews/PressQuotes.js